<a class="pointer no-decor" [href]="getProfileUrl()"> {{ displayName | titlecase | truncate: truncateAt }} </a>
